import React, {useState} from 'react';
import Header from "./components/Header/Header"
import Sidebar from './components/Sidebar/Sidebar';
import UserProfile from './pages/UserInfo/UserProfile'

const LandingPage = ({ children,handleLogin }) => {

    const [openUserProfile, setOpenUserProfile] = useState(false);
    const handleUserProfile = (value) =>{
        setOpenUserProfile(value)
    }
    return (
        <div>
         <Header handleUserProfile={handleUserProfile} handleLogin={handleLogin}/>
         {openUserProfile? <UserProfile handleUserProfile={handleUserProfile}/> : <Sidebar children={children}/>} 
        </div>
    );
};

export default LandingPage;
